import { AnikaWomacAnalytics } from "@/features/analytics/features/anika-womac/AnikaWomacAnalytics";
import { createFileRoute } from "@tanstack/react-router";

const AnikaAnalyticsPage = () => {
    return <AnikaWomacAnalytics />;
};

export const Route = createFileRoute("/_app/analytics/anika")({
    component: AnikaAnalyticsPage,
});
